export const picklistTypes = ["checkbox", "radio", "dropdown"];
